import { Text } from '@/decodo/components/atoms/Text';

import ExtraPricingRow from './ExtraPricingRow';
import Features from './Features';
import { PaymentMethods } from './PaymentMethods';
import PricingRow, { PricingRowProps } from './PricingRow';

import IconDone from '~/icons/check-circle.svg';
import IconBenefitHand from '~/svg/IconBenefitHand.svg';
import IconRocket from '~/svg/IconRocket.svg';
import IconShoppingCart from '~/svg/IconShoppingCart.svg';

//leaving a reminder that if the A/B test passes the component should be updated with translations
export const textGlobal = {
  subscriptionText: 'Get subscription',
  buyNow: 'Buy now',
  contactSalesText: 'Contact sales',
  contactSalesTitleText: 'Need more?',
  contactSalesDescriptionText:
    'Chat with us and we’ll find the best solution for you.',
  moneyBackText: '14 day money-back',
  featuresTitleText: 'With each subscription you access',
  paymentMethodsTitleText: 'SSL Secure Payment',
  paymentMethodsDescriptionText: 'Your information is protected by 256-bit SSL',
  subscription: 'SUBSCRIPTION',
  pricePerGb: 'PRICE PER GB',
  totalAmount: 'TOTAL AMOUNT',
} as const;

export type PricingRowsProps = {
  cards: {
    pricingCard: PricingRowProps;
  }[];
};

export default function PricingTable({ cards }: PricingRowsProps) {
  return (
    <div className='flex w-full flex-col items-center gap-8 md:gap-[60px]'>
      <div className='w-full'>
        <div className='dark:bg-gray-dark-800 mb-2 hidden rounded bg-gray-50 px-6 py-2 text-left  md:flex'>
          <Text
            variant='label-text-l'
            classNames={{ wrapper: 'basis-1/4 text-gray-500 font-serif' }}
          >
            {textGlobal.subscription}
          </Text>
          <Text
            variant='label-text-l'
            classNames={{ wrapper: 'basis-1/4 text-gray-500 font-serif' }}
          >
            {textGlobal.pricePerGb}
          </Text>
          <Text
            variant='label-text-l'
            classNames={{ wrapper: 'basis-2/4 text-gray-500 font-serif' }}
          >
            {textGlobal.totalAmount}
          </Text>
        </div>
        {cards.map((pricing, index) => (
          <PricingRow
            key={index}
            {...pricing.pricingCard}
            buttonText={pricing.pricingCard.buttonText || textGlobal.buyNow}
            url={pricing.pricingCard.url || '#contact-sales'}
            moneyBack={textGlobal.moneyBackText}
            icon={
              pricing.pricingCard.url === '#contact-sales' ? (
                <IconRocket />
              ) : (
                <IconShoppingCart />
              )
            }
          />
        ))}
        <ExtraPricingRow
          icon={<IconBenefitHand />}
          buttonText={textGlobal.contactSalesText}
          buttonLink='#contact-sales'
          title={textGlobal.contactSalesTitleText}
          description={textGlobal.contactSalesDescriptionText}
        />
      </div>
      <div className='w-full'>
        <Features
          title={textGlobal.featuresTitleText}
          icon={
            <IconDone className='text-brand-500 h-6 w-6 max-w-max scale-75' />
          }
        />
      </div>

      <PaymentMethods
        title={textGlobal.paymentMethodsTitleText}
        description={textGlobal.paymentMethodsDescriptionText}
      />
    </div>
  );
}
